import React, { useEffect, useState } from "react";
import "../../styles/styles.css";
import "../../styles/layout.css";
import * as Yup from "yup";
import { Modal, Button } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import MasterViewController from "../../redux/actions/masterApiActions";
import { useDispatch, useSelector } from "react-redux";

function DesignationFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const {addDesignation, updateDesignation} = MasterViewController();
  const { designations } = useSelector((state) => state.master);
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    name: ""
  });

  useEffect(() => {
    if (show && initialData) {
      setInitialValues({
        name: initialData.name || ""
      });
    } else if (show && !initialData) {
      setInitialValues({
        name: ""
      });
    }
  }, [show, initialData]);

  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updateDesignation(initialData.id, values)
      : addDesignation(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting designation form:", error);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title className="d-flex align-items-center">
                {isEdit ? "Edit Designation" : "Add Designation"}
                </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {() => (
                <Form>
                  <div className="mb-2">
                    <label>Designation Name</label>
                    <Field name="name" className="form-control" />
                  </div>
                  <Button type="submit" variant="primary" className="mt-3">
                    {isEdit ? "Update" : "Submit"}
                  </Button>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
  );
}

export default DesignationFormModal;

